<div>
  <!-- Left Sidebar -->
  <aside id="leftsidebar" class="sidebar">
    <div class="navbar-header">
      <a class="navbar-brand" routerLink="dashboard/dashboard1">
        <img src="assets/images/northrow-logo.png" class="sidebar-image" alt=""/>
      </a>
    </div>
    <!-- Menu -->
    <div class="menu">
      <ng-scrollbar [style.height]="listMaxHeight + 'px'" visibility="hover">
        <ul class="list">
          <!-- Top Most level menu -->
          <li [routerLinkActive]="'active-top'">
            <div class="header">Menu</div>

            <a [routerLink]="'organisation'" class="menu-top">
              <i-feather [name]="'briefcase'" class="sidebarIcon"></i-feather>
              <span class="hide-menu">Organisations</span>
            </a>

            <!--Admin-->
            <!--TODO should be changed to permission based not role based-->
            @if (authService.currentUserValue.role) {
              <a [routerLink]="'admin'" class="menu-top">
                <i-feather [name]="'lock'" class="sidebarIcon"></i-feather>

                <span [matBadge]="pendingCount | async" matBadgeSize="small" matBadgeColor="accent" class="hide-menu">Admin</span>
              </a>
            }

            <!--Billing-->
            <mat-expansion-panel class="menu-top-expansion">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <i-feather [name]="'dollar-sign'" class="sidebarIcon"></i-feather>
                  <span class="hide-menu">Billing</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <a [routerLink]="'billing/usage'" class="menu-top">
                <span class="hide-menu">Usage</span>
              </a>
              <a [routerLink]="'billing/invoicing'" class="menu-top">
                <span class="hide-menu">Invoicing</span>
              </a>
              <a [routerLink]="'billing/reconciliation'" class="menu-top">
                <span class="hide-menu">Reconciliation</span>
              </a>
<!--              <a [routerLink]="'billing/transactions'" class="menu-top">-->
<!--                <span class="hide-menu">Transactions</span>-->
<!--              </a>-->
            </mat-expansion-panel>

            <!--Engineering Tools-->
            <mat-expansion-panel class="menu-top-expansion">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>engineering</mat-icon>
                  <span class="icon-text">Dev Tools</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <a [routerLink]="'engineering/env-state'" class="menu-top">
                <span class="hide-menu">Env State</span>
              </a>
            </mat-expansion-panel>
          </li>
        </ul>
      </ng-scrollbar>
    </div>
    <div class="bottom-element">
      <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
        <app-feather-icons [icon]="menuIcon" [class]="'menuIcon'"></app-feather-icons>
      </button>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
</div>
